import { ApiKeyType } from "types/generated";

export const formatApiKeyType = (type: ApiKeyType) => {
  return type === ApiKeyType.Oidc ? "OIDC" : "Secret";
};
